export const USERS = "/Users";
export const AUTH_LOGIN = "/Login";
export const USER_FIELDS = "/UserFields";
export const PERMISSIONS = "/Permissions";
export const ROLES = "/Roles";
